import { Instagram } from "lucide-react";
import { MOVIE } from "@/constants/site";

export default function InstagramSection() {
  const href = `https://instagram.com/${MOVIE.instagramHandle}`;
  return (
    <section
      id="follow"
      className="relative py-20 sm:py-28 bg-fs-navy noise-overlay"
      data-testid="instagram-section"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-fs-orange mb-3">
              The Hive
            </p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-fs-cream leading-none">
              Follow the <span className="text-gradient-gold">Movie</span>
            </h2>
            <p className="mt-3 text-fs-silver max-w-xl">
              Behind-the-scenes art, score sessions, and squad updates straight
              from the production hive.
            </p>
          </div>
          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="btn-fs-primary self-start sm:self-auto"
            data-testid="instagram-handle-link"
          >
            <Instagram className="h-4 w-4" />
            @{MOVIE.instagramHandle}
          </a>
        </div>
      </div>
    </section>
  );
}
